import { useQuery } from '@tanstack/react-query';

import { HoofdstukSchemaObjectStatus } from '@/api';
import { useHoofdstuk } from '@/api/queries/objects';
import { groupHoofdstukkenByGrondslag } from '@/constants/grondslagen';
import { createInString } from '@/utils/createInString';

import { LabelEditorFilter } from '../-store/useLabelEditorStore';

export type HoofdstukkenWithLabelsQueryOptions = LabelEditorFilter & {
  besluitId: string;
};

const getHoofdstukkenWithLabelsQueryOptions = (
  props: HoofdstukkenWithLabelsQueryOptions
) => {
  return useHoofdstuk.getOptions(
    {
      page: 1,
      size: 100,
      filter: [
        props.type === 'showAllWithoutLabel'
          ? {
              model: 'Voorschrift',
              field: 'nolabel',
              op: 'eq',
              value: 'true',
            }
          : {
              model: 'Label',
              field: 'ID',
              op: 'in',
              value: createInString(props.labelIds),
            },
        {
          model: 'HB',
          field: 'Besluit',
          op: 'eq',
          value: props.besluitId,
        },
        {
          model: 'Hoofdstuk',
          field: 'Volgend',
          op: 'is_null',
          value: '',
        },
        {
          model: 'Hoofdstuk',
          field: 'ObjectStatus',
          op: 'ne',
          value: HoofdstukSchemaObjectStatus.IngetrokkenGepubliceerd,
        },
      ],
      sort: [
        {
          model: 'Hoofdstuk',
          field: 'Nummer',
          direction: 'asc',
        },
      ],
    },
    {
      select: ({ objects }) => groupHoofdstukkenByGrondslag(objects ?? []),
    }
  );
};

export const useHoofdstukkenWithLabels = (
  props: HoofdstukkenWithLabelsQueryOptions
) => {
  return useQuery(getHoofdstukkenWithLabelsQueryOptions(props));
};

useHoofdstukkenWithLabels.getOptions = getHoofdstukkenWithLabelsQueryOptions;
